/**
 * @fileoverview gRPC-Web generated client stub for auctionboost
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.35.1
// source: proto/management.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as proto_management_pb from '../proto/management_pb'; // proto import: "proto/management.proto"


export class ManagementServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateOrganization = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreateOrganization',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Organization,
    proto_management_pb.Organization,
    (request: proto_management_pb.Organization) => {
      return request.serializeBinary();
    },
    proto_management_pb.Organization.deserializeBinary
  );

  createOrganization(
    request: proto_management_pb.Organization,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Organization>;

  createOrganization(
    request: proto_management_pb.Organization,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void): grpcWeb.ClientReadableStream<proto_management_pb.Organization>;

  createOrganization(
    request: proto_management_pb.Organization,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreateOrganization',
        request,
        metadata || {},
        this.methodDescriptorCreateOrganization,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreateOrganization',
    request,
    metadata || {},
    this.methodDescriptorCreateOrganization);
  }

  methodDescriptorReadOrganization = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadOrganization',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Organization,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Organization.deserializeBinary
  );

  readOrganization(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Organization>;

  readOrganization(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void): grpcWeb.ClientReadableStream<proto_management_pb.Organization>;

  readOrganization(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadOrganization',
        request,
        metadata || {},
        this.methodDescriptorReadOrganization,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadOrganization',
    request,
    metadata || {},
    this.methodDescriptorReadOrganization);
  }

  methodDescriptorListOrganization = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListOrganization',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.Organization,
    proto_management_pb.Organization,
    (request: proto_management_pb.Organization) => {
      return request.serializeBinary();
    },
    proto_management_pb.Organization.deserializeBinary
  );

  listOrganization(
    request: proto_management_pb.Organization,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Organization> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListOrganization',
      request,
      metadata || {},
      this.methodDescriptorListOrganization);
  }

  methodDescriptorUpdateOrganization = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateOrganization',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Organization,
    proto_management_pb.Organization,
    (request: proto_management_pb.Organization) => {
      return request.serializeBinary();
    },
    proto_management_pb.Organization.deserializeBinary
  );

  updateOrganization(
    request: proto_management_pb.Organization,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Organization>;

  updateOrganization(
    request: proto_management_pb.Organization,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void): grpcWeb.ClientReadableStream<proto_management_pb.Organization>;

  updateOrganization(
    request: proto_management_pb.Organization,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Organization) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateOrganization',
        request,
        metadata || {},
        this.methodDescriptorUpdateOrganization,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateOrganization',
    request,
    metadata || {},
    this.methodDescriptorUpdateOrganization);
  }

  methodDescriptorDeleteOrganization = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/DeleteOrganization',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.DeletionResponse,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.DeletionResponse.deserializeBinary
  );

  deleteOrganization(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.DeletionResponse>;

  deleteOrganization(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.DeletionResponse>;

  deleteOrganization(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/DeleteOrganization',
        request,
        metadata || {},
        this.methodDescriptorDeleteOrganization,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/DeleteOrganization',
    request,
    metadata || {},
    this.methodDescriptorDeleteOrganization);
  }

  methodDescriptorCreatePerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreatePerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.Person,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Person.deserializeBinary
  );

  createPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Person>;

  createPerson(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void): grpcWeb.ClientReadableStream<proto_management_pb.Person>;

  createPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreatePerson',
        request,
        metadata || {},
        this.methodDescriptorCreatePerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreatePerson',
    request,
    metadata || {},
    this.methodDescriptorCreatePerson);
  }

  methodDescriptorReadPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadPerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Person,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Person.deserializeBinary
  );

  readPerson(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Person>;

  readPerson(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void): grpcWeb.ClientReadableStream<proto_management_pb.Person>;

  readPerson(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadPerson',
        request,
        metadata || {},
        this.methodDescriptorReadPerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadPerson',
    request,
    metadata || {},
    this.methodDescriptorReadPerson);
  }

  methodDescriptorListPeople = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListPeople',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.Person,
    proto_management_pb.Person,
    (request: proto_management_pb.Person) => {
      return request.serializeBinary();
    },
    proto_management_pb.Person.deserializeBinary
  );

  listPeople(
    request: proto_management_pb.Person,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Person> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListPeople',
      request,
      metadata || {},
      this.methodDescriptorListPeople);
  }

  methodDescriptorUpdatePerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdatePerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Person,
    proto_management_pb.Person,
    (request: proto_management_pb.Person) => {
      return request.serializeBinary();
    },
    proto_management_pb.Person.deserializeBinary
  );

  updatePerson(
    request: proto_management_pb.Person,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Person>;

  updatePerson(
    request: proto_management_pb.Person,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void): grpcWeb.ClientReadableStream<proto_management_pb.Person>;

  updatePerson(
    request: proto_management_pb.Person,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Person) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdatePerson',
        request,
        metadata || {},
        this.methodDescriptorUpdatePerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdatePerson',
    request,
    metadata || {},
    this.methodDescriptorUpdatePerson);
  }

  methodDescriptorDeletePerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/DeletePerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.DeletionResponse,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.DeletionResponse.deserializeBinary
  );

  deletePerson(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.DeletionResponse>;

  deletePerson(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.DeletionResponse>;

  deletePerson(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/DeletePerson',
        request,
        metadata || {},
        this.methodDescriptorDeletePerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/DeletePerson',
    request,
    metadata || {},
    this.methodDescriptorDeletePerson);
  }

  methodDescriptorCreateAuctionSeries = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreateAuctionSeries',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.AuctionSeries,
    proto_management_pb.AuctionSeries,
    (request: proto_management_pb.AuctionSeries) => {
      return request.serializeBinary();
    },
    proto_management_pb.AuctionSeries.deserializeBinary
  );

  createAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.AuctionSeries>;

  createAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void): grpcWeb.ClientReadableStream<proto_management_pb.AuctionSeries>;

  createAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreateAuctionSeries',
        request,
        metadata || {},
        this.methodDescriptorCreateAuctionSeries,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreateAuctionSeries',
    request,
    metadata || {},
    this.methodDescriptorCreateAuctionSeries);
  }

  methodDescriptorReadAuctionSeries = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadAuctionSeries',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.AuctionSeries,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.AuctionSeries.deserializeBinary
  );

  readAuctionSeries(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.AuctionSeries>;

  readAuctionSeries(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void): grpcWeb.ClientReadableStream<proto_management_pb.AuctionSeries>;

  readAuctionSeries(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadAuctionSeries',
        request,
        metadata || {},
        this.methodDescriptorReadAuctionSeries,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadAuctionSeries',
    request,
    metadata || {},
    this.methodDescriptorReadAuctionSeries);
  }

  methodDescriptorListAuctionSeries = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListAuctionSeries',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.AuctionSeries,
    proto_management_pb.AuctionSeries,
    (request: proto_management_pb.AuctionSeries) => {
      return request.serializeBinary();
    },
    proto_management_pb.AuctionSeries.deserializeBinary
  );

  listAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.AuctionSeries> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListAuctionSeries',
      request,
      metadata || {},
      this.methodDescriptorListAuctionSeries);
  }

  methodDescriptorUpdateAuctionSeries = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateAuctionSeries',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.AuctionSeries,
    proto_management_pb.AuctionSeries,
    (request: proto_management_pb.AuctionSeries) => {
      return request.serializeBinary();
    },
    proto_management_pb.AuctionSeries.deserializeBinary
  );

  updateAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.AuctionSeries>;

  updateAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void): grpcWeb.ClientReadableStream<proto_management_pb.AuctionSeries>;

  updateAuctionSeries(
    request: proto_management_pb.AuctionSeries,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.AuctionSeries) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateAuctionSeries',
        request,
        metadata || {},
        this.methodDescriptorUpdateAuctionSeries,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateAuctionSeries',
    request,
    metadata || {},
    this.methodDescriptorUpdateAuctionSeries);
  }

  methodDescriptorDeleteAuctionSeries = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/DeleteAuctionSeries',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.DeletionResponse,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.DeletionResponse.deserializeBinary
  );

  deleteAuctionSeries(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.DeletionResponse>;

  deleteAuctionSeries(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.DeletionResponse>;

  deleteAuctionSeries(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/DeleteAuctionSeries',
        request,
        metadata || {},
        this.methodDescriptorDeleteAuctionSeries,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/DeleteAuctionSeries',
    request,
    metadata || {},
    this.methodDescriptorDeleteAuctionSeries);
  }

  methodDescriptorCreateAuction = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreateAuction',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Auction,
    proto_management_pb.Auction,
    (request: proto_management_pb.Auction) => {
      return request.serializeBinary();
    },
    proto_management_pb.Auction.deserializeBinary
  );

  createAuction(
    request: proto_management_pb.Auction,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Auction>;

  createAuction(
    request: proto_management_pb.Auction,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void): grpcWeb.ClientReadableStream<proto_management_pb.Auction>;

  createAuction(
    request: proto_management_pb.Auction,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreateAuction',
        request,
        metadata || {},
        this.methodDescriptorCreateAuction,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreateAuction',
    request,
    metadata || {},
    this.methodDescriptorCreateAuction);
  }

  methodDescriptorReadAuction = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadAuction',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Auction,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Auction.deserializeBinary
  );

  readAuction(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Auction>;

  readAuction(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void): grpcWeb.ClientReadableStream<proto_management_pb.Auction>;

  readAuction(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadAuction',
        request,
        metadata || {},
        this.methodDescriptorReadAuction,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadAuction',
    request,
    metadata || {},
    this.methodDescriptorReadAuction);
  }

  methodDescriptorListAuction = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListAuction',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.Auction,
    proto_management_pb.Auction,
    (request: proto_management_pb.Auction) => {
      return request.serializeBinary();
    },
    proto_management_pb.Auction.deserializeBinary
  );

  listAuction(
    request: proto_management_pb.Auction,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Auction> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListAuction',
      request,
      metadata || {},
      this.methodDescriptorListAuction);
  }

  methodDescriptorUpdateAuction = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateAuction',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Auction,
    proto_management_pb.Auction,
    (request: proto_management_pb.Auction) => {
      return request.serializeBinary();
    },
    proto_management_pb.Auction.deserializeBinary
  );

  updateAuction(
    request: proto_management_pb.Auction,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Auction>;

  updateAuction(
    request: proto_management_pb.Auction,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void): grpcWeb.ClientReadableStream<proto_management_pb.Auction>;

  updateAuction(
    request: proto_management_pb.Auction,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Auction) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateAuction',
        request,
        metadata || {},
        this.methodDescriptorUpdateAuction,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateAuction',
    request,
    metadata || {},
    this.methodDescriptorUpdateAuction);
  }

  methodDescriptorDeleteAuction = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/DeleteAuction',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.DeletionResponse,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.DeletionResponse.deserializeBinary
  );

  deleteAuction(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.DeletionResponse>;

  deleteAuction(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.DeletionResponse>;

  deleteAuction(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/DeleteAuction',
        request,
        metadata || {},
        this.methodDescriptorDeleteAuction,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/DeleteAuction',
    request,
    metadata || {},
    this.methodDescriptorDeleteAuction);
  }

  methodDescriptorCreateItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreateItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Item,
    proto_management_pb.EntityReference,
    (request: proto_management_pb.Item) => {
      return request.serializeBinary();
    },
    proto_management_pb.EntityReference.deserializeBinary
  );

  createItem(
    request: proto_management_pb.Item,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.EntityReference>;

  createItem(
    request: proto_management_pb.Item,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.EntityReference) => void): grpcWeb.ClientReadableStream<proto_management_pb.EntityReference>;

  createItem(
    request: proto_management_pb.Item,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.EntityReference) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreateItem',
        request,
        metadata || {},
        this.methodDescriptorCreateItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreateItem',
    request,
    metadata || {},
    this.methodDescriptorCreateItem);
  }

  methodDescriptorReadItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Item,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Item.deserializeBinary
  );

  readItem(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Item>;

  readItem(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Item) => void): grpcWeb.ClientReadableStream<proto_management_pb.Item>;

  readItem(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Item) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadItem',
        request,
        metadata || {},
        this.methodDescriptorReadItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadItem',
    request,
    metadata || {},
    this.methodDescriptorReadItem);
  }

  methodDescriptorListItems = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListItems',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.SearchTerm,
    proto_management_pb.Item,
    (request: proto_management_pb.SearchTerm) => {
      return request.serializeBinary();
    },
    proto_management_pb.Item.deserializeBinary
  );

  listItems(
    request: proto_management_pb.SearchTerm,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Item> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListItems',
      request,
      metadata || {},
      this.methodDescriptorListItems);
  }

  methodDescriptorUpdateItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Item,
    proto_management_pb.Response,
    (request: proto_management_pb.Item) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  updateItem(
    request: proto_management_pb.Item,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  updateItem(
    request: proto_management_pb.Item,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  updateItem(
    request: proto_management_pb.Item,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateItem',
        request,
        metadata || {},
        this.methodDescriptorUpdateItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateItem',
    request,
    metadata || {},
    this.methodDescriptorUpdateItem);
  }

  methodDescriptorDeleteItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/DeleteItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.Response,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  deleteItem(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  deleteItem(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  deleteItem(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/DeleteItem',
        request,
        metadata || {},
        this.methodDescriptorDeleteItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/DeleteItem',
    request,
    metadata || {},
    this.methodDescriptorDeleteItem);
  }

  methodDescriptorCheckInPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CheckInPerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.CheckedInResponse,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.CheckedInResponse.deserializeBinary
  );

  checkInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.CheckedInResponse>;

  checkInPerson(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckedInResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.CheckedInResponse>;

  checkInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckedInResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CheckInPerson',
        request,
        metadata || {},
        this.methodDescriptorCheckInPerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CheckInPerson',
    request,
    metadata || {},
    this.methodDescriptorCheckInPerson);
  }

  methodDescriptorReadGuest = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadGuest',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.Guest,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Guest.deserializeBinary
  );

  readGuest(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Guest>;

  readGuest(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Guest) => void): grpcWeb.ClientReadableStream<proto_management_pb.Guest>;

  readGuest(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Guest) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ReadGuest',
        request,
        metadata || {},
        this.methodDescriptorReadGuest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ReadGuest',
    request,
    metadata || {},
    this.methodDescriptorReadGuest);
  }

  methodDescriptorUpdateGuest = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateGuest',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.Guest,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Guest.deserializeBinary
  );

  updateGuest(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Guest>;

  updateGuest(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Guest) => void): grpcWeb.ClientReadableStream<proto_management_pb.Guest>;

  updateGuest(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Guest) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateGuest',
        request,
        metadata || {},
        this.methodDescriptorUpdateGuest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateGuest',
    request,
    metadata || {},
    this.methodDescriptorUpdateGuest);
  }

  methodDescriptorListGuests = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListGuests',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.SearchTerm,
    proto_management_pb.Guest,
    (request: proto_management_pb.SearchTerm) => {
      return request.serializeBinary();
    },
    proto_management_pb.Guest.deserializeBinary
  );

  listGuests(
    request: proto_management_pb.SearchTerm,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Guest> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListGuests',
      request,
      metadata || {},
      this.methodDescriptorListGuests);
  }

  methodDescriptorUpdateCheckedInPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateCheckedInPerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.CheckedInResponse,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.CheckedInResponse.deserializeBinary
  );

  updateCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.CheckedInResponse>;

  updateCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckedInResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.CheckedInResponse>;

  updateCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckedInResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateCheckedInPerson',
        request,
        metadata || {},
        this.methodDescriptorUpdateCheckedInPerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateCheckedInPerson',
    request,
    metadata || {},
    this.methodDescriptorUpdateCheckedInPerson);
  }

  methodDescriptorRemoveCheckedInPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/RemoveCheckedInPerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Guest,
    proto_management_pb.DeletionResponse,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.DeletionResponse.deserializeBinary
  );

  removeCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.DeletionResponse>;

  removeCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.DeletionResponse>;

  removeCheckedInPerson(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.DeletionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/RemoveCheckedInPerson',
        request,
        metadata || {},
        this.methodDescriptorRemoveCheckedInPerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/RemoveCheckedInPerson',
    request,
    metadata || {},
    this.methodDescriptorRemoveCheckedInPerson);
  }

  methodDescriptorClerkItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ClerkItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.ClerkedItem,
    proto_management_pb.ClerkItemResponse,
    (request: proto_management_pb.ClerkedItem) => {
      return request.serializeBinary();
    },
    proto_management_pb.ClerkItemResponse.deserializeBinary
  );

  clerkItem(
    request: proto_management_pb.ClerkedItem,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.ClerkItemResponse>;

  clerkItem(
    request: proto_management_pb.ClerkedItem,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.ClerkItemResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.ClerkItemResponse>;

  clerkItem(
    request: proto_management_pb.ClerkedItem,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.ClerkItemResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/ClerkItem',
        request,
        metadata || {},
        this.methodDescriptorClerkItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/ClerkItem',
    request,
    metadata || {},
    this.methodDescriptorClerkItem);
  }

  methodDescriptorListClerkedItems = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListClerkedItems',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.SearchTerm,
    proto_management_pb.ClerkedItem,
    (request: proto_management_pb.SearchTerm) => {
      return request.serializeBinary();
    },
    proto_management_pb.ClerkedItem.deserializeBinary
  );

  listClerkedItems(
    request: proto_management_pb.SearchTerm,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.ClerkedItem> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListClerkedItems',
      request,
      metadata || {},
      this.methodDescriptorListClerkedItems);
  }

  methodDescriptorUpdateClerkedItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/UpdateClerkedItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.ClerkedItem,
    proto_management_pb.ClerkedItem,
    (request: proto_management_pb.ClerkedItem) => {
      return request.serializeBinary();
    },
    proto_management_pb.ClerkedItem.deserializeBinary
  );

  updateClerkedItem(
    request: proto_management_pb.ClerkedItem,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.ClerkedItem>;

  updateClerkedItem(
    request: proto_management_pb.ClerkedItem,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.ClerkedItem) => void): grpcWeb.ClientReadableStream<proto_management_pb.ClerkedItem>;

  updateClerkedItem(
    request: proto_management_pb.ClerkedItem,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.ClerkedItem) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/UpdateClerkedItem',
        request,
        metadata || {},
        this.methodDescriptorUpdateClerkedItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/UpdateClerkedItem',
    request,
    metadata || {},
    this.methodDescriptorUpdateClerkedItem);
  }

  methodDescriptorRemoveClerkedItem = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/RemoveClerkedItem',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.DeletionRequest,
    proto_management_pb.Response,
    (request: proto_management_pb.DeletionRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  removeClerkedItem(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  removeClerkedItem(
    request: proto_management_pb.DeletionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  removeClerkedItem(
    request: proto_management_pb.DeletionRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/RemoveClerkedItem',
        request,
        metadata || {},
        this.methodDescriptorRemoveClerkedItem,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/RemoveClerkedItem',
    request,
    metadata || {},
    this.methodDescriptorRemoveClerkedItem);
  }

  methodDescriptorListCheckedInGuests = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ListCheckedInGuests',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.SearchTerm,
    proto_management_pb.Guest,
    (request: proto_management_pb.SearchTerm) => {
      return request.serializeBinary();
    },
    proto_management_pb.Guest.deserializeBinary
  );

  listCheckedInGuests(
    request: proto_management_pb.SearchTerm,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Guest> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ListCheckedInGuests',
      request,
      metadata || {},
      this.methodDescriptorListCheckedInGuests);
  }

  methodDescriptorGetUnpaidPurchasedItems = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/GetUnpaidPurchasedItems',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.Guest,
    proto_management_pb.ClerkedItem,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.ClerkedItem.deserializeBinary
  );

  getUnpaidPurchasedItems(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.ClerkedItem> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/GetUnpaidPurchasedItems',
      request,
      metadata || {},
      this.methodDescriptorGetUnpaidPurchasedItems);
  }

  methodDescriptorGetInvoices = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/GetInvoices',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.Guest,
    proto_management_pb.Invoice,
    (request: proto_management_pb.Guest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Invoice.deserializeBinary
  );

  getInvoices(
    request: proto_management_pb.Guest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Invoice> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/GetInvoices',
      request,
      metadata || {},
      this.methodDescriptorGetInvoices);
  }

  methodDescriptorGetInvoicePresignedURL = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/GetInvoicePresignedURL',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Invoice,
    proto_management_pb.Response,
    (request: proto_management_pb.Invoice) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  getInvoicePresignedURL(
    request: proto_management_pb.Invoice,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  getInvoicePresignedURL(
    request: proto_management_pb.Invoice,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  getInvoicePresignedURL(
    request: proto_management_pb.Invoice,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/GetInvoicePresignedURL',
        request,
        metadata || {},
        this.methodDescriptorGetInvoicePresignedURL,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/GetInvoicePresignedURL',
    request,
    metadata || {},
    this.methodDescriptorGetInvoicePresignedURL);
  }

  methodDescriptorCheckoutPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CheckoutPerson',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.CheckoutPersonRequest,
    proto_management_pb.CheckoutPersonResponse,
    (request: proto_management_pb.CheckoutPersonRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.CheckoutPersonResponse.deserializeBinary
  );

  checkoutPerson(
    request: proto_management_pb.CheckoutPersonRequest,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.CheckoutPersonResponse>;

  checkoutPerson(
    request: proto_management_pb.CheckoutPersonRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckoutPersonResponse) => void): grpcWeb.ClientReadableStream<proto_management_pb.CheckoutPersonResponse>;

  checkoutPerson(
    request: proto_management_pb.CheckoutPersonRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.CheckoutPersonResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CheckoutPerson',
        request,
        metadata || {},
        this.methodDescriptorCheckoutPerson,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CheckoutPerson',
    request,
    metadata || {},
    this.methodDescriptorCheckoutPerson);
  }

  methodDescriptorCreateInvoice = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/CreateInvoice',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.Invoice,
    proto_management_pb.Invoice,
    (request: proto_management_pb.Invoice) => {
      return request.serializeBinary();
    },
    proto_management_pb.Invoice.deserializeBinary
  );

  createInvoice(
    request: proto_management_pb.Invoice,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Invoice>;

  createInvoice(
    request: proto_management_pb.Invoice,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Invoice) => void): grpcWeb.ClientReadableStream<proto_management_pb.Invoice>;

  createInvoice(
    request: proto_management_pb.Invoice,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Invoice) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/CreateInvoice',
        request,
        metadata || {},
        this.methodDescriptorCreateInvoice,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/CreateInvoice',
    request,
    metadata || {},
    this.methodDescriptorCreateInvoice);
  }

  methodDescriptorReadCheckedoutPerson = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/ReadCheckedoutPerson',
    grpcWeb.MethodType.SERVER_STREAMING,
    proto_management_pb.CheckoutPersonRequest,
    proto_management_pb.Person,
    (request: proto_management_pb.CheckoutPersonRequest) => {
      return request.serializeBinary();
    },
    proto_management_pb.Person.deserializeBinary
  );

  readCheckedoutPerson(
    request: proto_management_pb.CheckoutPersonRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<proto_management_pb.Person> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/auctionboost.ManagementService/ReadCheckedoutPerson',
      request,
      metadata || {},
      this.methodDescriptorReadCheckedoutPerson);
  }

  methodDescriptorMarkInvoiceVoid = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/MarkInvoiceVoid',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Response,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  markInvoiceVoid(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  markInvoiceVoid(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  markInvoiceVoid(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/MarkInvoiceVoid',
        request,
        metadata || {},
        this.methodDescriptorMarkInvoiceVoid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/MarkInvoiceVoid',
    request,
    metadata || {},
    this.methodDescriptorMarkInvoiceVoid);
  }

  methodDescriptorMarkInvoicePaid = new grpcWeb.MethodDescriptor(
    '/auctionboost.ManagementService/MarkInvoicePaid',
    grpcWeb.MethodType.UNARY,
    proto_management_pb.EntityReference,
    proto_management_pb.Response,
    (request: proto_management_pb.EntityReference) => {
      return request.serializeBinary();
    },
    proto_management_pb.Response.deserializeBinary
  );

  markInvoicePaid(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null): Promise<proto_management_pb.Response>;

  markInvoicePaid(
    request: proto_management_pb.EntityReference,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void): grpcWeb.ClientReadableStream<proto_management_pb.Response>;

  markInvoicePaid(
    request: proto_management_pb.EntityReference,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_management_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/auctionboost.ManagementService/MarkInvoicePaid',
        request,
        metadata || {},
        this.methodDescriptorMarkInvoicePaid,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/auctionboost.ManagementService/MarkInvoicePaid',
    request,
    metadata || {},
    this.methodDescriptorMarkInvoicePaid);
  }

}

